import React from 'react';
import Hero from '../components/Hero';
import FeaturedMunicipalities from '../components/FeaturedMunicipalities';
import Allies from '../components/Allies';
import useSEO from '../hooks/useSEO';
import FeaturedProperties from '../components/FeaturedProperties';

const HomePage = () => {
  // SEO específico para la página de inicio
  useSEO({
    title: 'JD Propiedad Raíz | Encuentra tu hogar ideal en Medellín y alrededores',
    description: 'Descubre las mejores propiedades en venta y arriendo en Medellín, Envigado, Sabaneta e Itagüí. Expertos en bienes raíces.',
    keywords: 'propiedad raiz, inmobiliaria Medellín, venta de casas, arriendo de apartamentos, bienes raices, propiedades en venta, Envigado, Sabaneta, Itagüí',
    ogImage: `${window.location.origin}/logo512.png`,
    ogUrl: window.location.href,
    canonicalUrl: window.location.href,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      "name": "JD Propiedad Raíz",
      "description": "Inmobiliaria especializada en venta y arriendo de propiedades en Medellín y sus alrededores",
      "url": window.location.origin,
      "logo": `${window.location.origin}/logo512.png`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Medellín",
        "addressRegion": "Antioquia",
        "addressCountry": "CO"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Medellín"
        },
        {
          "@type": "City", 
          "name": "Envigado"
        },
        {
          "@type": "City",
          "name": "Sabaneta"
        },
        {
          "@type": "City",
          "name": "Itagüí"
        }
      ]
    }
  });

  return (
    <article className="home-page bg-brand-white">
      <section className="hero-section relative z-0">
        <Hero />
      </section>
      {/* seccion de Inmuebles destacados*/}
      <section className='bg-brand-black'>
        <div>
          <FeaturedProperties />
        </div>

      </section>
      
      {/* Sección de Municipios Destacados con nueva identidad de marca y animaciones */}
      <section 
        className="featured-section relative z-10 py-20 bg-brand-black text-brand-white overflow-hidden"
       
      >
        <div className="container mx-auto px-4 text-center">
          <h2 
            className="text-4xl md:text-5xl font-bold text-brand-gold mb-4 animate-fade-in-down"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
          >
            Municipios Destacados
          </h2>
          <p className="text-lg text-brand-beige mb-12 max-w-3xl mx-auto animate-fade-in-up">
            Explora las mejores propiedades en las ubicaciones más cotizadas. Tu próximo hogar te espera.
          </p>
          <div className="animate-fade-in" style={{ animationDelay: '0.5s' }}>
            <FeaturedMunicipalities />
          </div>
        </div>
      </section>

      <Allies />
    </article>
  );
};

export default HomePage;
